import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '@src/models';
import { PrivateRoute, PrivateRouteProps } from './PrivateRoute';
import { DefaultPrivateRoute } from './DefaultPrivateRoute';

export const CandidatePrivateRoute = observer(({ component, ...rest }: PrivateRouteProps) => {
  const {
    authStore: { isFetching },
    userStore: { isCandidate }
  } = useStore();

  if (isFetching) {
    return null;
  }

  return <PrivateRoute component={isCandidate ? component : DefaultPrivateRoute} {...rest} />;
});
